/**
 * This file contains many functions that make calls to our API and return the promises from those calls.
 */
import queryString from 'querystring';

import Api from '../api.ts';

const VALIDATION = '/validations';
const AUTHENTICATION = '/authentication';

const ValidationAPI = {
  validateBIC(bic) {
    return Api.get(`${VALIDATION}/bic?${queryString.encode({ bic })}`);
  },

  validateIBAN(iban) {
    return Api.get(`${VALIDATION}/iban?${queryString.encode({ iban })}`);
  },

  validateTIN(params) {
    return Api.get(`${VALIDATION}/tin?${queryString.encode(params)}`);
  },

  get2faMethods() {
    return Api.get(`${VALIDATION}/2fa-methods`);
  },

  get2faCode(params) {
    return Api.get(`${VALIDATION}/2fa?${queryString.encode(params)}`);
  },

  get2faCodeLogin(params) {
    return Api.post(`${AUTHENTICATION}/get-2fa-code`, { data: { ...params } });
  },

  verify2faCode(params) {
    return Api.post(`${VALIDATION}/2fa?${queryString.encode(params)}`);
  },
};

export default ValidationAPI;
